export default __webpack_public_path__ + "static/media/responsive-robot-illu.b781fc92.svg";